module.exports = __webpack_public_path__ + "d7a978663206f154d733143a251c605d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/poster/video-fast.jpg
// module id = 296
// module chunks = 0